import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { db } from '../firebase';
import { collection, getDocs, query, orderBy } from 'firebase/firestore';
import { PlusCircle, Edit } from 'lucide-react';

export default function AdminLearningPage() {
    const [articles, setArticles] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchArticles = async () => {
            const q = query(collection(db, 'learning_articles'), orderBy('createdAt', 'desc'));
            const snapshot = await getDocs(q);
            setArticles(snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() })));
            setLoading(false);
        };
        fetchArticles();
    }, []);

    return (
        <div className="glass-card rounded-2xl p-8">
            <div className="flex justify-between items-center mb-6">
                <h1 className="text-3xl font-bold text-white">Manage Learning Articles</h1>
                <Link to="/admin/learning/new" className="flex items-center gap-2 bg-cyan-500 hover:bg-cyan-400 text-black font-bold py-2 px-4 rounded-lg">
                    <PlusCircle size={20} />
                    New Article
                </Link>
            </div>
            <div className="space-y-4">
                {loading ? <p className="text-white">Loading articles...</p> : articles.map(article => (
                    <div key={article.id} className="glass-card p-4 rounded-lg flex justify-between items-center">
                        <div>
                            <h3 className="font-bold text-white">{article.title}</h3>
                            <p className={`text-sm ${article.published ? 'text-green-400' : 'text-yellow-400'}`}>
                                {article.published ? 'Published' : 'Draft'}
                            </p>
                        </div>
                        <Link to={`/admin/learning/edit/${article.id}`} className="flex items-center gap-2 bg-slate-700 hover:bg-slate-600 text-white font-semibold py-2 px-4 rounded-lg">
                            <Edit size={16} />
                            Edit
                        </Link>
                    </div>
                ))}
            </div>
        </div>
    );
}